import React from 'react';
import PropTypes from 'prop-types';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/Icons
import { ErrorOutline } from '@material-ui/icons';

// core components

import Card from 'components/Card/Card.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CustomTabs from 'components/CustomTabs/CustomTabs.jsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TransactionStyle from 'assets/jss/material-dashboard-pro-react/views/TransactionStyle';
import AthHistory from './PayableAthHistory';
import BthHistory from './PayableBthHistory';
import ReimbursementHistory from './PayableReimbursementHistory';
import ExceptionHistory from './PayableExceptionHistory';

import { switchActivePage } from '../../../reducers/transactions';
import apiCaller from '../../../utils/apiCallerOutstanding';
import firebase from '../../../config/config';
import formatDate from '../../../utils/convertDateFormat';
import currencyFormat from '../../../utils/toIndianCurrencyString';
import logger from '../../../utils/logger';

const db = firebase.firestore();

class PayoutsHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bthScheduled: false,
      bthScheduledAmount: '',
      bthScheduledDate: '',
      pendingEditTransactionCount: 0,
    };
    this.hideDetailedForm = this.hideDetailedForm.bind(this);
  }

  componentDidMount() {
    this.bthScheduledAmountStatus();
    this.fetchPendingCount();
  }

  // eslint-disable-next-line react/sort-comp
  hideDetailedForm() {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.switchActivePage(false);
  }

  /**
   * Will return the Tabs ATH and BTH
   * @function
   */
  // eslint-disable-next-line class-methods-use-this
  getTabs() {
    const { currentTransactionData } = this.props;
    const { pendingEditTransactionCount } = this.state;
    return (
      <CustomTabs
        headerColor="#fff"
        tabs={[
          {
            tabName: 'ATH',
            tabContent: (
              <AthHistory
                currentTransactionData={currentTransactionData}
                pendingEditTransactionCount={pendingEditTransactionCount}
              />
            ),
          },
          {
            tabName: 'BTH',
            tabContent: (
              <BthHistory
                currentTransactionData={currentTransactionData}
                pendingEditTransactionCount={pendingEditTransactionCount}
              />
            ),
          },
          {
            tabName: 'Exception',
            tabContent: (
              <ExceptionHistory
                currentTransactionData={currentTransactionData}
                pendingEditTransactionCount={pendingEditTransactionCount}
              />
            ),
          },
          {
            tabName: 'Reimbursement',
            tabContent: (
              <ReimbursementHistory
                currentTransactionData={currentTransactionData}
                pendingEditTransactionCount={pendingEditTransactionCount}
              />
            ),
          },
        ]}
      />
    );
  }

  async bthScheduledAmountStatus() {
    const { currentTransactionData } = this.props;

    const userDetails = firebase.auth().currentUser;
    const { Aa: token } = userDetails;

    const endPoint = `pipe/payment-schedule-detail?type=bth_payable&trip_id=${currentTransactionData.transactionId}`;

    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${token}`,
        'nh-base',
        'get'
      );
      const data = response?.data;
      this.setState({
        bthScheduled: data.scheduled,
        bthScheduledAmount: data.scheduled_bth_amount,
        bthScheduledDate: data.date,
      });
    } catch (e) {
      logger.error('Error', e);
    }
  }

  async getPendingEditTransactionsCount() {
    const { currentTransactionData } = this.props;
    const transactionRef = db.collection('Transactions');
    try {
      const querySnapshot = await transactionRef
        .where(
          'transactionSerial',
          '==',
          currentTransactionData?.transactionSerial
        )
        .where('isEditedTransaction', '==', true)
        .where('status', '==', 'pending')
        .get();
      return querySnapshot.size;
    } catch (e) {
      return 0;
    }
  }

  fetchPendingCount = () => {
    this.getPendingEditTransactionsCount().then(count => {
      this.setState({ pendingEditTransactionCount: count });
    });
  };

  render() {
    const { classes, currentPayableAmount, activeRole } = this.props;
    const {
      bthScheduled,
      bthScheduledAmount,
      bthScheduledDate,
      pendingEditTransactionCount,
    } = this.state;
    return (
      <Card>
        <CardHeader
          className={`${classes.cardHeader}`}
          style={{
            marginBottom: '1px',
            paddingBottom: '1px',
            paddingTop: '1px',
          }}
        >
          <h3 className={classes.cardTitle}>
            Payable:{' '}
            <i
              className="fa fa-inr"
              style={{ fontSize: '22px' }}
              aria-hidden="true"
            />{' '}
            {Intl.NumberFormat('en-IN').format(currentPayableAmount)}
            <small />
          </h3>
          {bthScheduled && (
            <p
              style={{
                color: '#163BAC',
                margin: '5px 0px 0px 0px',
                fontSize: '16px',
              }}
            >
              {currencyFormat(bthScheduledAmount)} BTH is scheduled for{' '}
              {formatDate(bthScheduledDate)}
            </p>
          )}
          {pendingEditTransactionCount > 0 &&
            (activeRole === 'finance' || activeRole === 'finance-payable') && (
              <p
                style={{
                  color: '#FC7F3B',
                  backgroundColor: '#FFF2EB',
                  padding: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  borderBottom: '1px solid #FC7F3B',
                }}
              >
                <ErrorOutline />
                Transaction is awaiting approval. The &#34;Payable&#34; button
                will be enabled once it&#39;s approved or rejected.
              </p>
            )}
        </CardHeader>
        <CardBody
          style={{
            marginBottom: '1px',
            paddingBottom: '1px',
            paddingTop: '1px',
          }}
        >
          {this.getTabs()}
        </CardBody>
      </Card>
    );
  }
}

PayoutsHistory.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  isDetailedPage: state.transactions.isDetailedPage,
  // currentTransactionData: state.transactions.currentTransactionData,
  transactions: state.transactions.transactions,
  payableTransactions: state.transactions.payableTransactions,
  currentPayableAmount: state.transactions.currentPayableAmount,
  activeRole: state.main.activeRole,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      switchActivePage,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(TransactionStyle)(PayoutsHistory));
